import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class TabContent extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired
  }

  render() {
    const { children } = this.props

    return (
      <div>
        {children}
      </div>
    )
  }
}
